<template>

    <div id="agility_tab" class="flex_content" >

        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <TableWrapper tableContainerId="positions_table_container">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th data-tooltip="Score de matching">%</th>
                            <th>{{ labels['R_1'] }}</th>
                            <th>{{ labels['E_2'] }}</th>
                            <th>{{ labels['S_3'] }}</th>
                            <th>{{ labels['P_4'] }}</th>
                            <th>{{ labels['E_5'] }}</th>
                            <th>{{ labels['C_6'] }}</th>
                            <th>{{ labels['T_7'] }}</th>
                        </tr>

                    </template>

                    <template v-slot:tableBody>

                        <!--
                        <tr class="ref_line">
                            <td class="eval_username">{{ $t('modules.positions.evals_detail.ref_score') }}</td>
                            <td>-</td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.R_1.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.E_2.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.S_3.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.P_4.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.E_5.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.C_6.toFixed(0) }}</div></td>
                            <td><div class="ref_score">{{ evaluations[0].saven_test.respect_scores.sight_ref.T_7.toFixed(0) }}</div></td>
                        </tr>
                        -->

                        <tr class=""
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>
                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>

                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.R_1.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.R_1.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.E_2.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.E_2.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.S_3.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.S_3.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.P_4.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.P_4.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.E_5.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.E_5.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.C_6.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.C_6.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.respect_scores.candidate.T_7.toFixed(0))">
                                    {{ evaluation.saven_test.respect_scores.candidate.T_7.toFixed(0) }}
                                </div>
                            </td>

                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>

import respectLabels from '@/locales/respectLabels'


export default {
    name: 'PostitionEvalsRespectTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
    components: {},
    beforeCreate() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            return respectLabels[this.$i18n.locale]
        }
    },
    methods: {
        matchingClass(val){
            if(val < 25){return 'low'}
            if(val >= 25 && val < 50){return 'middleLow'}
            if(val >= 50 && val < 75){return 'middleHigh'}
            if(val >= 75){return 'high'}
        },
        scoreClass(score){
            return "is_score_" + score
        }
    }
}
</script>

<style lang="scss" scoped>
th{
    text-align: center!important;
}
.sortable_column{
    cursor: pointer;
}
th.active{
    background: #d2ddea;
}
td{
    text-align: center;
    color: #8f9aaa;
    height: 42px!important;
    padding-top: 6px!important;
    padding-bottom: 6px!important;
}
.data_table_view {
    padding-top: 50px;
}
.evaluation_item_name{

    .circle_score{
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        font-weight: 600;
        font-size: 1.2rem;
        background: $info;
        color: $white;
        margin: auto;
        &.is_score_1{
            background-color: $score-diff5;
        }
        &.is_score_2{
            background-color: $score-diff4;
        }
        &.is_score_3{
            background-color: $score-diff3;
        }
        &.is_score_4{
            background-color: $score-diff2;
        }
        &.is_score_5{
            background-color: $score-diff1;
        }
    }
}
.matching_col{
    font-weight: 700;
    font-size: 1.25rem;
    &.low{
        color: $score-diff4;
    }
    &.middleLow{
        color: $score-diff3;
    }
    &.middleHigh{
        color: $score-diff2;
    }
    &.high{
        color: $score-diff1;
    }
}
.eval_username{
    text-align: left!important;
}
td.eval_username{
    text-align: left!important;
    font-weight: 500;
}
</style>